import React from "react";
import { RootStateOrAny, useSelector, useDispatch } from "react-redux";
import { Panel } from "office-ui-fabric-react";
import { useTranslation } from "react-i18next";
import { toggleAddStoreDocPanel } from "../../../config/redux/storeDocs/storeDocsActions";
import { panelS } from "../../common/styles/panelStyles";
import StoreDocsAddForm from "../components/StoreDocsAddForm";
import StoreDocsShowForm from "../components/StoreDocsShowForm";

const StoreDocsPanel: React.FC = () => {
    const { t } = useTranslation("admin");
    const dispatch = useDispatch();
    const { toggleStoreDocsPanel, toggleStoreDocsPanelToAdd } = useSelector(
        (state: RootStateOrAny) => state.storeDocs
    );

    const dismissPanel = () => {
        dispatch(toggleAddStoreDocPanel({ isOpen: false, add: false }));
    };

    return (
        <Panel
            isOpen={toggleStoreDocsPanel}
            closeButtonAriaLabel={t("nav.close") as string}
            headerText={toggleStoreDocsPanelToAdd ? t("nav.panelAddDocument") as string : t("nav.panelDocumentDetails") as string}
            onDismiss={dismissPanel}
            type={3}
            styles={panelS}
            isHiddenOnDismiss={false}
        >
            {toggleStoreDocsPanelToAdd ?
                <StoreDocsAddForm /> :
                <StoreDocsShowForm />
            }
        </Panel>
    );
};

export default StoreDocsPanel;